export default __webpack_public_path__ + "static/media/bg-2.cae7b14e.jpg";